<template>
  <div>
    <BModal
      id="modal-spending-fee"
      hide-footer
      hide-header
      :centered="true"
      content-class="rounded-lg"
      dialog-class="modal-spending-fee"
    >
      <div class="p-1">
        <h1 class="font-semibold text-[18px] text-[#333333] text-center mb-2">
          Sesuaikan Fee Top Up
        </h1>
        <div class="mb-1 text-[#333333]">
          <span>Persentase fee top up:</span>
          <BFormSelect
            v-model="selectedFeePercentage"
            :options="feePercentageOptions"
            class="mb-1"
          />
        </div>
        <div class="flex flex-row gap-6">
          <BButton
            variant="outline-primary"
            class="rounded grow"
            @click="closeModalSpendingFee"
          >
            Batal
          </BButton>

          <BButton
            variant="primary"
            class="rounded grow"
            @click="showConfirmationModal"
          >
            Simpan
          </BButton>
        </div>
      </div>
    </BModal>

    <!-- Modal Konfirmasi Perubahan Fee -->
    <BModal
      id="modal-confirmation-fee"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      hide-footer
      hide-header
      :centered="true"
      style="width: 600px;"
    >
      <div class="text-center">
        <img
          src="https://storage.googleapis.com/komerce/core/icon-popup-warning.png"
          alt="Komerce"
          class="m-auto mb-2"
          width="80px"
        >
        <div class="font-semibold text-2xl text-black my-2">
          Konfirmasi Perubahan Fee Top Up
        </div>
        <p class="text-black mb-2">
          Kamu akan mengubah persentase fee Top Up partner dari
          {{ currentFeePercentage }}% menjadi {{ selectedFeePercentage }}%.
          Perubahan ini akan langsung diterapkan pada seluruh transaksi Top Up.
        </p>
        <div class="flex flex-row gap-6">
          <BButton
            size="md"
            variant="outline-primary"
            class="rounded grow"
            @click="$bvModal.hide('modal-confirmation-fee')"
          >
            Batal
          </BButton>
          <BButton
            size="md"
            variant="primary"
            class="rounded grow"
            @click="confirmFeeChange"
          >
            Ya, Simpan
          </BButton>
        </div>
      </div>
    </BModal>
  </div>
</template>

<script>
export default {
  props: {
    currentFeePercentage: {
      type: Number,
      default: 5,
    },
  },
  data() {
    return {
      selectedFeePercentage: this.currentFeePercentage,
      feePercentageOptions: [
        { value: 2, text: '2%' },
        { value: 2.5, text: '2.5%' },
        { value: 3, text: '3%' },
        { value: 3.5, text: '3.5%' },
        { value: 4, text: '4%' },
        { value: 4.5, text: '4.5%' },
        { value: 5, text: '5%' },
      ],
    }
  },
  watch: {
    currentFeePercentage(newValue) {
      this.selectedFeePercentage = newValue
    },
  },
  methods: {
    // Show confirmation modal before saving fee percentage
    showConfirmationModal() {
      this.$bvModal.show('modal-confirmation-fee')
    },

    closeModalSpendingFee() {
      this.selectedFeePercentage = this.currentFeePercentage
      this.$bvModal.hide('modal-spending-fee')
    },

    confirmFeeChange() {
      this.$emit('update-fee', this.selectedFeePercentage)
      this.closeModalSpendingFee()
      this.$bvModal.hide('modal-confirmation-fee')
    },
  },
}
</script>

<style scoped>
::v-deep .modal-spending-fee .modal-content {
  border-radius: 8px;
  border: 1px solid #e2e2e2;
}
</style>
